export default {
    stickers: {
        title: 'Klistremerker',
        stickerOpacity: 'Klistremerke gjennomsiktighet',
        stickerColor: 'Klistremerkefarge',
        shapes: {
            title: ' Former',
            rectangle: 'Rektangel',
            circle: 'Sirkel',
            triangle: 'Trekant',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
